<template>
  <router-link class="items-container__item item" :class="{ 'add-new-item': item.isNewRoute }" :to="item.isNewRoute ? { name: 'add-zone' } : { name: 'zone', params: {id: item.id}}">
    <div class="item__row item__title">
      <span>{{ item.isNewRoute ? item.name : item.code }}</span>
    </div>

    <div class="item__statusbar" v-if="!item.isNewRoute"><span class="filling" style="width: 0%"></span></div>
    <div class="item__row item__subtitle" v-if="!item.isNewRoute">
      <span>
        <span>{{ item.address }}</span>
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: ['item'],
};
</script>



// WEBPACK FOOTER //
// src/components/zones/ListItemTemplate.vue